import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const setSkillMapLine = api(async function setSkillMapLine({ skillMapId, line }) {
    return mutate(
        gql`
            mutation SetSkillMapLine($skillMapId: String!, $line: SkillMapLineInput!) {
                setSkillMapLine(skillMapId: $skillMapId, line: $line) {
                    id
                    skillId
                    tradeId
                    conditionalTrades {
                        id
                        name
                        conditions {
                            field
                            operator
                            value
                        }
                        combinator
                        tradeId
                        sortOrder
                    }
                }
            }
        `,
        { skillMapId, line },
        { returns: "setSkillMapLine" }
    )
})
